"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScrollParent = void 0;

var getScrollParent = function getScrollParent(node) {
  var regex = /(auto|scroll)/;

  var parents = function parents(_node, ps) {
    if (_node.parentNode === null) {
      return ps;
    }

    return parents(_node.parentNode, ps.concat([_node]));
  };

  var style = function style(_node, prop) {
    return getComputedStyle(_node, null).getPropertyValue(prop);
  };

  var overflow = function overflow(_node) {
    return style(_node, 'overflow') + style(_node, 'overflow-y') + style(_node, 'overflow-x');
  };

  var scroll = function scroll(_node) {
    return regex.test(overflow(_node)) && _node.scrollHeight > _node.clientHeight;
  };
  /* eslint-disable consistent-return */


  var scrollParent = function scrollParent(_node) {
    if (!(_node instanceof HTMLElement || _node instanceof SVGElement)) {
      return;
    }

    var ps = parents(_node.parentNode, []);

    for (var i = 0; i < ps.length; i += 1) {
      if (scroll(ps[i])) {
        return ps[i];
      }
    }

    return document.scrollingElement || document.documentElement;
  };

  return scrollParent(node);
  /* eslint-enable consistent-return */
};

exports.getScrollParent = getScrollParent;
//# sourceMappingURL=scrollbars.js.map